<fm-context-menu [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  menuName="Garmin Stop"
  [latLng]="menuData.markerInfo?.latLng"
  i18n-menuName="@@S_GARMIN_STOP">
  <fm-context-menu-panel>
    <fm-context-menu-item *ngIf="userPermissions.findNearest"
      [hasSeparator]="true"
      id="lnk-garmin-find-nearest"
      (click)="onFindNearestClicked()">
      <a i18n="@@S_FIND_NEAREST">Find nearest</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-garmin-zoom-to"
      (click)="onZoomToClicked()">
      <a i18n="@@S_ZOOM_TO">Zoom to</a>
    </fm-context-menu-item>
    <fm-context-menu-item [hasSeparator]="true"
      id="lnk-garmin-street-view"
      [isDisabled]="!menuData.streetViewAvailable"
      (click)="onStreetViewClicked()">
      <a i18n="@@S_STREET_VIEW">Street view</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.createGeofence"
      [hasSeparator]="true"
      id="lnk-garmin-create-geofence-here"
      (click)="onCreateGeofenceClicked()">
      <a i18n="@@S_CREATE_A_GEOFENCE_HERE">Create a Geofence here</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-garmin-open-dispatch-window"
      (click)="onDispatchWindow()">
      <a i18n="@@S_GARMINCONTEXTMENU_DISPWINDOW">Open Dispatch Window</a>
    </fm-context-menu-item>
    <fm-context-menu-item [hasSeparator]="true"
      id="lnk-garmin-view-status-history"
      (click)="onViewStatusHistory()">
      <a i18n="@@S_GARMINCONTEXTMENU_STATUSHISTORY">View Status History</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions"
      id="lnk-garmin-get-directions-to-here"
      (click)="onGetDirectionToClicked()">
      <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions"
      id="lnk-garmin-get-directions-from-here"
      (click)="onGetDirectionFromClicked()">
      <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
    </fm-context-menu-item>
  </fm-context-menu-panel>
</fm-context-menu>
